import React, {Component} from 'react';

class AppCommonHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    redirectToApp = () => {
        if(!this.props.isBackWebPage) {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: "goHome",
                }));
                window.location.href = "/#";
            }
        } else {
            this.props.goBackButtn();
        }    
    }

    render() {
        return(
            <header id="header" className='dgAppBackHeader'>
                <div className="container-fluid">
                    <div className='dgAppBackHeaderInn'>
                        <a href='javascript:void(0)' onClick={(e) => this.redirectToApp()}><i className='iArrow-Left' /></a>
                        {!this.props.isBackWebPage && <span>Back to Home</span>}
                    </div>
                </div>
            </header>
        )
    }
}
export default AppCommonHeader